import { SubscriptionStatus } from '@showbie-socrative/socrative-utils';
import { useAtomValue } from 'jotai/index';

import { selectedTeamIdAtom } from '~teacher/components/Account/atoms';
import { useTeams } from '~teacher/hook/team';

export function useTeamSubscriptionQuery(teamId: string) {
  return useTeams({
    select: (teams) => {
      const team = teams.find((team) => team.id === teamId);
      return team?.subscription;
    },
  });
}

export function useSelectedTeamHasActiveSubscriptionQuery() {
  const selectedTeamId = useAtomValue(selectedTeamIdAtom);
  const subscriptionStatusQuery = useTeamSubscriptionQuery(selectedTeamId);

  if (!subscriptionStatusQuery.isSuccess) {
    return { data: undefined };
  }

  const status = subscriptionStatusQuery.data?.status;
  return {
    data:
      status !== undefined &&
      [SubscriptionStatus.Active, SubscriptionStatus.Trialing].includes(status),
  };
}

export function useSelectedTeamHasDisputedSubscription() {
  const selectedTeamId = useAtomValue(selectedTeamIdAtom);
  const subscriptionStatusQuery = useTeamSubscriptionQuery(selectedTeamId);

  if (!subscriptionStatusQuery.isSuccess) {
    return { data: undefined };
  }

  const status = subscriptionStatusQuery.data?.status;
  return {
    data: status === SubscriptionStatus.Disputed,
  };
}
